import React, { useEffect } from 'react'
import ReactGA from 'react-ga4'
import { Route, Switch } from 'react-router-dom'
import { withOidcSecure } from '@axa-fr/react-oidc-context'
import { useLocation } from 'react-router-dom'

import Events from './events/Events'
import Event from './event/Layout'
import Compare from './compare/Layout'
import NotFound from './not-found/NotFound'
import config from '../config'

ReactGA.initialize([{
        trackingId: config.GOOGLE_ANALYTICS,
        testMode: process.env.NODE_ENV === 'development',
        gaOptions: {
            environment: config.ENVIRONMENT_TYPE,
        },
    }
])

const useGoogleAnalyticsPageViews = () => {
    let location = useLocation()

    useEffect(
      () => {
        ReactGA.send({ hitType: "pageview", page: location.pathname, title: window.document.title })
      },
      [location]
    )
}

const Routes = () => {
    useGoogleAnalyticsPageViews()
    
    return (
        <Route>
            <Switch>
                <Route exact path="/" component={Events} />
                <Route path="/events/:id" component={Event} />
                <Route path="/events" component={Events} />
                <Route path="/compare" component={Compare} />
                <Route path="*" component={NotFound} />
            </Switch>
        </Route>
    )
}

export default withOidcSecure(Routes)
